import {
  showCurrencyAsCode,
  getCurrencyFractionDigitsOptions,
} from "root/libs/constants/src";

export function getDiscountPercent(original, discounted) {
  if (!original || !discounted || original === 0) return 0;
  return Math.round(((original - discounted) / original) * 100);
}

export function formatCurrency({
  amount,
  currency,
  locale,
  showIsoCode,
  isCurrencyCodeAvailable,
}) {
  if (!isCurrencyCodeAvailable) {
    return amount != null
      ? new Intl.NumberFormat(locale, { minimumFractionDigits: 2 }).format(
          amount
        )
      : "";
  }
  if (showIsoCode) {
    return `${currency} ${new Intl.NumberFormat(
      locale,
      getCurrencyFractionDigitsOptions(currency)
    ).format(amount)}`;
  }

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    currencyDisplay: showCurrencyAsCode.includes(currency) ? "code" : "symbol",
  }).format(amount);
}

export const getCopy = (intl, id, variables) => {
  return intl.formatMessage({ id }, variables);
};
